<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import type { LetterSelectionDraft, LetterSelectionRow } from "../../contract"
  import LetterAppointmentTag from "../../../../_shared/_modules/letter-appointment-tag"
  let props: InboxWorkflowCellProps<LetterSelectionRow, LetterSelectionDraft> = $props()
</script>
<LetterAppointmentTag row={props.row} />
